import { c as _c } from "react-compiler-runtime";
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function formatTimestamp(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${String(secs).padStart(2, '0')}`;
}
function shouldShowSpeakerLabel(utterance, index, utterances) {
  if (index === 0) return true;
  return utterances[index - 1].speakerName !== utterance.speakerName;
}
export const PublicTranscriptCard = t0 => {
  const $ = _c(10);
  const {
    transcript
  } = t0;
  const [expanded, setExpanded] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(Text, {
      typography: "heading-200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "external-sharing-components.transcriptCard.heading"
      })
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setExpanded(_temp);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== expanded) {
    t3 = /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "200",
      marginBlockEnd: "200",
      children: [t1, /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        size: "extra-small",
        onClick: t2,
        children: expanded ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "external-sharing-components.transcriptCard.hide"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "external-sharing-components.transcriptCard.show"
        })
      })]
    });
    $[2] = expanded;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== expanded || $[5] !== transcript) {
    t4 = expanded && /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "300",
      children: transcript.utterances.map((utterance, index) => {
        const showSpeaker = shouldShowSpeakerLabel(utterance, index, transcript.utterances);
        return /*#__PURE__*/_jsxs(View, {
          children: [showSpeaker && /*#__PURE__*/_jsxs(Flex, {
            gap: "100",
            alignItems: "baseline",
            marginBlockEnd: "100",
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "heading-100",
              children: utterance.speakerName
            }), /*#__PURE__*/_jsx(Text, {
              typography: "detail-100",
              color: "text-core-subtle",
              children: formatTimestamp(utterance.startTimeSeconds)
            })]
          }), /*#__PURE__*/_jsx(Text, {
            typography: "body-100",
            children: utterance.text
          })]
        }, utterance.id);
      })
    });
    $[4] = expanded;
    $[5] = transcript;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsxs(CardSection, {
        children: [t3, t4]
      })
    });
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp(prev) {
  return !prev;
}